module.exports = __webpack_public_path__ + "img/office.6d682e87.png";